// 問い合わせフォーム (#1930 / #1932)。**ログイン不要の公開口**なので、他のドメインと違い
// トークンを前提にしない。種別 (category) のコードはサーバの
// CONTACT_CATEGORY_LABELS と 1:1 で、表示名はこちらの翻訳を使う。
//
// #1932 スクリーンショットを添えられるようにしたため **multipart で送る**。
// 添付の有無で送り方を変えると経路が 2 本になるので、常に multipart。
import { apiFetch, ApiError } from './_client'

export type ContactCategory = 'partnership' | 'bug' | 'account' | 'store' | 'other'

/** 画面に出す順番。サーバは知らない値が来ても 'other' に倒すので、増減しても壊れない。 */
export const CONTACT_CATEGORIES: ContactCategory[] = [
  'partnership',
  'bug',
  'account',
  'store',
  'other',
]

/** #1932 添付できる枚数と 1 枚の大きさ。サーバ側でも同じ上限で弾く。 */
export const CONTACT_MAX_FILES = 3
export const CONTACT_MAX_FILE_BYTES = 5 * 1024 * 1024

export type ContactInput = {
  category: ContactCategory
  name: string
  email: string
  message: string
  /** 店舗の方が任意で入れる店名 */
  storeName?: string
  /** どの画面から来たか (運営が見るときの手がかり) */
  source: 'customer' | 'store'
  locale: string
  /** ハニーポット。人には見えない項目なので、常に空で送る */
  website?: string
  /** #1932 直近に見ていた画面。不具合の再現に効く */
  recentRoutes?: string[]
  /** #1932 アプリのバージョン (Sentry の release と同じ値) */
  appVersion?: string
  /** #1932 スクリーンショット。送る前に縮小・JPEG 化してある */
  files?: File[]
}

export const contactApi = {
  async sendContactInquiry(input: ContactInput) {
    const body = new FormData()
    body.append('category', input.category)
    body.append('name', input.name)
    body.append('email', input.email)
    body.append('message', input.message)
    body.append('storeName', input.storeName || '')
    body.append('source', input.source)
    body.append('locale', input.locale)
    body.append('website', input.website || '')
    body.append('recentRoutes', (input.recentRoutes || []).join(' > '))
    body.append('appVersion', input.appVersion || '')
    for (const f of input.files || []) body.append('files', f, f.name)

    // Content-Type は付けない。**boundary はブラウザにしか決められない**ので、
    // 手で書くと本文を読めない (400 になる)。
    const res = await apiFetch('/contact', { method: 'POST', body })
    if (!res.ok) throw new ApiError(res.status, 'Failed to send inquiry')
    return res.json() as Promise<{ ok: boolean; id: string }>
  },
}
